module.exports = __webpack_public_path__ + "img/selected0-min.dff5a736.png";